import { useState } from 'react'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import Organizacao from '../../middleware/Organizacao'
import SubMenuOpcoes from '../SubMenuOpcoes'
import ModulosContratados from '../../middleware/SistemasContratados'
import Permissoes from '../../middleware/Permissoes'

function MenuOpcoesRecrutamento(props: menuOpcoes) {

  const [subMenu, setSubMenu] = useState(false)

  function exibirSubMenu() {
    setSubMenu(subMenu => !subMenu)
  }

  return (
    <ModulosContratados modulo={["Recrutamento"]}>
         <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'recrutamento_acesso']}>
            <div>
            <div id="menuOpcoes" onClick={exibirSubMenu}>
                {<img src={props.icone} alt={props.alt} id="iconeMenu" />}
                <p id='tituloMenu'>{props.titulo}</p>
                <h3>Novo</h3>
            </div>
            <div id="submenuOpcoes">
                <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'recrutamento_todos']}>
                    {subMenu && <SubMenuOpcoes redirect={'/processos-seletivos'} texto='Todos os Recrutamentos' />}
                </Permissoes>
                <Permissoes permissoes={['master', 'consultor', 'recrutamento_meus']}>
                    {subMenu && <SubMenuOpcoes redirect={'/processos-seletivos?meus-processos=true'} texto='Meus Recrutamentos' />}
                </Permissoes>
                <Permissoes permissoes={['master', 'atendimento', 'administrativo', 'recrutamento_nps']}>
                    {subMenu && <SubMenuOpcoes redirect={'/processo-seletivo-nps'} texto='Nps' />}
                </Permissoes>
                <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
                    <>
                        <Permissoes permissoes={['master', 'recrutamento_disc']}>
                                {subMenu && <SubMenuOpcoes redirect={'/questionario-disc'} texto='Questionário Disc' />}
                        </Permissoes>
                        <Permissoes permissoes={['master', 'consultor', 'recrutamento_banco_talentos']}>
                            {subMenu && <SubMenuOpcoes redirect={'/banco-talentos'} texto='Banco de Talentos' />}
                        </Permissoes>
                    </>
                </Organizacao>
            </div>
            </div>
        </Permissoes>
    </ModulosContratados>
  )
}

export default MenuOpcoesRecrutamento
